var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer",class:( _obj = {}, _obj[("footer-" + _vm.type)] = _vm.type, _obj ),attrs:{"data-background-color":_vm.backgroundColor}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"copyright"},[_vm._v(" © 2017 - "+_vm._s(_vm.year)+", made with "),_c('md-icon',[_vm._v("favorite")]),_vm._v(" by Dear Future. ")],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }